module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex-start"
        }, [_c('div', {
          staticClass: "kaojicenter-lefts mr10"
        }, [_c('img', {
          staticClass: "img",
          attrs: {
            "src": scope.row.pic_url,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "kaojicenter-rights"
        }, [_c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('div', {
          staticClass: "desc flex-start"
        }, [_c('el-tag', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "round": "",
            "color": _vm._f("color")(scope.row.grade),
            "type": "primary"
          }
        }, [_vm._v(_vm._s(scope.row.grade) + "星级")]), _vm._v("  \n                  " + _vm._s(scope.row.num) + "\n                ")], 1)])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "default",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.onActionSelect(scope.row.id, 0)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "default",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.onActionSelect(scope.row.id, 2)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.row.totalpage > 1) ? _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.formData.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a49c52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyMemberList.vue
// module id = 1331
// module chunks = 0